import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";

import { SidebarService, ISidebarResponse } from "@azm/core/services/sidebar";

export const sidebarResolver: ResolveFn<ISidebarResponse | null> = (_route, _state) => {
	const sidebarService = inject(SidebarService);

	return sidebarService.sidebarItems();
};
